import React from 'react';
import { Dropdown } from 'antd';
import './styles.scss';

export default function CustomDropdown(props) {
	return <Dropdown {...props} />;
}
